export class SourceCategory {
  private readonly __v = 1;
  private readonly _id: string;
  name: string;
  categoryId: string;

  // todo remove the any
  constructor(sourceCategoryObj: any) {
    if (sourceCategoryObj == null) {
      return;
    }
    this._id = crypto.randomUUID();
    this.name = sourceCategoryObj.name;
    this.categoryId = sourceCategoryObj.categoryId;
  }

  get id(): string {
    return this._id;
  }
}
